/**
 * Use it create correct string from template(pattern) and object with data.
 * If data is not object or pattern is empty it just returns not modified received data.
 *
 * @param data {object} - object with fields mentioned in the template param
 * @param pattern {string} - string template in format "$(^weekday)$ $(dayOfMonth)$ tussen $(timeFrom)$ en $(timeTo)$ uur"
 *      text placed into $()$ will be parsed like a property in parameter "data" object
 *      if you use symbol '^' after '$(' - it will capitalize current part of template
 *
 * @returns $(*)$ returns correct string with correctly replaced template parts,
 *      or not modified 'data' param if arguments are not valid
 * _______________________
 * For example:
 * data = {
 *      weekday: 'monday',
 *      month: 'September'
 * };
 *
 * pattern = 'Some text here $(weekday)$, $(^weekday)$, $(month)$, $(^month)$, some text here...'
 *
 * will return string:
 * 'Some text here monday, Monday, September, September, some text here...'
 *
 * '^' doesn't capitalize September because it's already capitalized in the source 'data',
 * no automatic lowercase logic if '^' is missed
 */
export const templateToString = (data, pattern) => {
    if (!pattern || !data || typeof data !== 'object') {
        return data;
    }

    return pattern.replace(/\$\([^)$]*\)\$/g, match => {
        const templateData = match.substring(2, match.length - 2);
        const needCapitilize = templateData && templateData.startsWith('^');
        const fieldPath = needCapitilize ? templateData.substring(1) : templateData;

        let value = (fieldPath && data[fieldPath]) || '';

        if (needCapitilize && value) {
            value = value.replace(/^\w/, c => c.toUpperCase());
        }

        return value;
    });
};
